import React, { useState } from 'react';
import '../App.css';
import Footer from '../Footer';
import './Form.css';

const FileUpload = () => {
  const [file, setFile] = useState(null);
  const [fileName, setFileName]= useState("No file chosen");
  const [buttonText, setButtonText] = useState("Upload");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleFileChange = (event) => {
    const upfile = event.target.files[0]
    setFile(event.target.files[0]);
    setFileName(upfile ? upfile.name : "No file chosen");
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!file) return alert("Please select a file");

    const formData = new FormData();
    formData.append("file", file);
    setButtonText("Uploading...");
    setIsSubmitting(true);

    try {
      const response = await fetch("https://rma-sj.onrender.com/upload", {
        method: "POST",
        body: formData,
      });

      setButtonText("Done!");
      setTimeout(() => {
        setButtonText("Upload"); // Reset button text after 2 seconds
        setIsSubmitting(false);
      }, 2000);
      // const data = await response.json();
      // alert(data.message);
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className='file-input-section'>
        <label for="file-upload" className="file-input-label">Choose File</label>
        <span id="file-name" className='file-input-span'>{fileName}</span>
        <input id='file-upload' type="file" accept="application/pdf" className='file-input' onChange={handleFileChange} disabled={isSubmitting}/>
      </div>
      <div className='file-input-section'>
        <button type="submit" className={`upload-btn ${isSubmitting ? "disabled" : ""}`}>{buttonText}</button>
      </div>
    </form>
  );
};


export default function Form() {
  return (
    <>
    {/* <div className="form">APPLY NOW</div> */}
    <div className='file-upload-section'>
      <div className='file-upload-section-wrapper'>
        <div className='file-upload-header'>
          <h1>Apply now quick and easy!</h1>
        </div>
        <div className='step-1'>
          <h2>Step 1: Fill out our RMA Mortgage Application form</h2>
          <a href="/RMA-Fillable-Form.pdf" target="_blank" rel="noopener noreferrer" className='open-fillable-btn'>
              <button className='open-pdf-btn'>Open PDF</button>
          </a>
        </div>
        <div className='step-2'>
          <h2>Step 2: Upload your pdf and submit your application</h2>
          <FileUpload/>
        </div>
        <div className='conclusion'>
          <h2>That is it! <a href='/contact' className='contact-link'>Contact us</a> if you have any questions!</h2>
        </div>
        {/* <div className='file-upload-images-wrapper'>
          <div className='file-upload-images'>
            <img src='/images/contract-signing.jpg'/>
            <p className='file-upload-images-h2'>Fill out the provided form and save a copy</p>
          </div>
          <div className='file-upload-images'>
            <img src='/images/email-laptop.jpg'/>
            <p className='file-upload-images-h2'>Upload your form and send it to us and we'll be in touch ASAP!</p>
          </div>
        </div> */}
      </div>
    </div>
    <Footer />
    </>
  );
}